import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  radioGroupLabel: {
    color: theme.palette.common.gray800,
    marginBottom: theme.spacing(1),
  },
  radioOptionsContainer: {
    marginLeft: theme.spacing(2),
  },
  radioLabel: {
    marginBottom: theme.spacing(1),
  },
}));
